//common
import './common';

//components


import FancyboxPreview from './blocks/fancybox'
import ArticleCarousel from './blocks/slider-article'
import './blocks/pagination'

addEventListener('ajax:update-complete', () => {
    FancyboxPreview.initFancybox();
    ArticleCarousel.init();
})